import { NetflixRow, NetflixCard } from './NetflixRow';

export const EducationRow = () => {
  const education = [
    {
      title: "MIT Sloan Executive Education",
      subtitle: "Cybersecurity Leadership for Executives",
      description: "Advanced executive education focused on cybersecurity risk management, strategic governance, and leadership frameworks for managing cyber risks in enterprise environments. Specialized curriculum designed for C-level executives and senior leaders to build cyber-aware organizational cultures.",
      match: "Executive Education",
      tags: ["Executive Leadership", "Cyber Risk Management", "Strategic Governance"],
      imageSrc: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800",
      link: "https://executive.mit.edu/whychoosemitsloan.html",
      institution: "Massachusetts Institute of Technology",
      focus: "Management & Leadership in Cybersecurity"
    },
    {
      title: "University of Florida - Hough Graduate School of Business",
      subtitle: "Information Systems & Operations Management (ISOM)",
      description: "Comprehensive graduate program in Information Systems and Operations Management focusing on enterprise technology strategy, risk management, and operational excellence. Advanced coursework in cybersecurity governance, risk quantification, and technology leadership for business transformation.",
      match: "Graduate Education",
      tags: ["Information Systems", "Operations Management", "Risk Strategy"],
      imageSrc: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800",
      link: "https://warrington.ufl.edu/",
      institution: "University of Florida",
      focus: "Information Systems & Risk Management"
    },
    {
      title: "Bhilai Institute of Technology, Durg",
      subtitle: "Technology Foundation & Engineering Excellence",
      description: "Foundational education in technology and engineering principles, providing the technical foundation for understanding complex cybersecurity challenges, system architecture, and risk assessment methodologies. Strong emphasis on analytical thinking and problem-solving approaches.",
      match: "Engineering Foundation",
      tags: ["Engineering Foundation", "Technical Systems", "Analytical Methods"],
      imageSrc: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=800",
      link: "https://bitdurg.ac.in/home",
      institution: "Bhilai Institute of Technology, Durg",
      focus: "Technology & Engineering Fundamentals"
    }
  ];

  const certifications = [
    {
      title: "CCISO - Certified Chief Information Security Officer",
      subtitle: "EC-Council • Executive Security Leadership",
      description: "Executive-level certification demonstrating strategic cybersecurity leadership capabilities, business alignment skills, and governance expertise required for C-level security positions in enterprise environments. Focuses on executive decision-making and organizational risk management.",
      match: "Executive Level",
      tags: ["Executive Leadership", "Strategic Planning", "C-Level"],
      imageSrc: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800",
      link: "https://www.eccouncil.org/programs/chief-information-security-officer-cciso/"
    },
    {
      title: "CISSP - Certified Information Systems Security Professional",
      subtitle: "(ISC)² • Gold Standard Security Certification",
      description: "Gold standard certification in information security demonstrating expertise across eight domains of cybersecurity including security architecture, risk management, security operations, and asset security. Globally recognized as the premier cybersecurity certification.",
      match: "Gold Standard",
      tags: ["Security Architecture", "Risk Management", "Global Standard"],
      imageSrc: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800",
      link: "https://www.isc2.org/Certifications/CISSP"
    },
    {
      title: "CISM - Certified Information Security Manager",
      subtitle: "ISACA • Security Management Excellence",
      description: "Advanced certification focusing on information security management, governance, risk management, and incident response management capabilities for senior security professionals. Emphasizes strategic security program development and management.",
      match: "Management Expert",
      tags: ["Security Management", "Governance", "Strategic Program Development"],
      imageSrc: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800",
      link: "https://www.isaca.org/credentialing/cism"
    },
    {
      title: "CRISC - Certified in Risk and Information Systems Control",
      subtitle: "ISACA • Risk Management Specialization",
      description: "Specialized certification in IT risk management and information systems control, demonstrating expertise in risk identification, assessment, evaluation, and response strategies. Focus on risk-based approach to cybersecurity and control implementation.",
      match: "Risk Specialist",
      tags: ["Risk Management", "IT Controls", "Risk Assessment"],
      imageSrc: "https://images.unsplash.com/photo-1552581234-26160f608093?w=800",
      link: "https://www.isaca.org/credentialing/crisc"
    },
    {
      title: "CISA - Certified Information Systems Auditor",
      subtitle: "ISACA • Audit & Assurance Excellence",
      description: "Premier certification for information systems audit, control, and assurance professionals. Demonstrates expertise in auditing information systems, evaluating controls, and ensuring compliance with regulatory requirements and industry standards.",
      match: "Audit Professional",
      tags: ["Information Systems Audit", "Compliance", "Assurance"],
      imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800",
      link: "https://www.isaca.org/credentialing/cisa"
    },
    {
      title: "PMP - Project Management Professional",
      subtitle: "PMI • Project Leadership Excellence",
      description: "Global standard for project management excellence, demonstrating advanced skills in leading cross-functional teams, managing complex initiatives, and delivering strategic outcomes. Essential for managing enterprise-scale cybersecurity programs and transformations.",
      match: "Project Leader",
      tags: ["Project Management", "Leadership", "Strategic Delivery"],
      imageSrc: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800",
      link: "https://www.pmi.org/certifications/project-management-pmp"
    },
    {
      title: "GCIH - GIAC Certified Incident Handler",
      subtitle: "SANS/GIAC • Incident Response Excellence",
      description: "Advanced certification in cybersecurity incident handling and digital forensics. Demonstrates hands-on skills in incident detection, response coordination, and forensic analysis essential for managing security operations and incident response programs.",
      match: "Incident Response",
      tags: ["Incident Response", "Digital Forensics", "Security Operations"],
      imageSrc: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800",
      link: "https://www.giac.org/certifications/certified-incident-handler-gcih/"
    },
    {
      title: "GCSA - GIAC Cloud Security Automation",
      subtitle: "SANS/GIAC • Cloud Security Expertise",
      description: "Specialized certification in cloud security architecture, automation, and DevSecOps practices. Demonstrates expertise in securing cloud environments, implementing automated security controls, and managing cloud security at scale.",
      match: "Cloud Expert",
      tags: ["Cloud Security", "Automation", "DevSecOps"],
      imageSrc: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800",
      link: "https://www.giac.org/certifications/cloud-security-automation-gcsa/"
    }
  ];

  const handleCardClick = (item, type) => {
    if (item.link) {
      window.open(item.link, '_blank');
    }
  };

  return (
    <>
      <NetflixRow title="Education & Academic Excellence" id="education">
        {education.map((edu, index) => (
          <NetflixCard
            key={index}
            title={edu.title}
            subtitle={edu.subtitle}
            description={edu.description}
            match={edu.match}
            tags={edu.tags}
            imageSrc={edu.imageSrc}
            onClick={() => handleCardClick(edu, 'education')}
          />
        ))}
      </NetflixRow>
      
      <NetflixRow title="Professional Certifications">
        {certifications.map((cert, index) => (
          <NetflixCard
            key={index}
            title={cert.title}
            subtitle={cert.subtitle}
            description={cert.description}
            match={cert.match}
            tags={cert.tags}
            imageSrc={cert.imageSrc}
            onClick={() => handleCardClick(cert, 'certification')}
          />
        ))}
      </NetflixRow>
    </>
  );
};